import { noop } from "lodash";
import { createContext } from "react";

export const DialogContext = createContext<{ onClose: () => void; titleID: string }>({
  onClose: noop,
  titleID: "",
});
